import React from 'react'
import { Table } from 'semantic-ui-react'
import * as R from 'ramda'
import styled from 'styled-components'
import Popup from 'shared/components/Popup'
import humps from 'humps'
import { QuestionAction } from './QuestionAction'
import { LinkButton } from 'elements/LinkButton'
import useFeatureToggle from 'hooks/useFeatureToggle'
import useSurveyChoiceOrder from 'hooks/useSurveyChoiceOrder'
import { sortConditionsBySentiment } from 'libs/questions'

const TableStyled = styled(Table)`
  .tblcustom.pleft {
    padding-left: 24px;
  }

  .tblcustom.pright {
    padding-right: 24px;
  }
`

export default function QuestionActions({
  questionAction,
  isPrimary,
  open,
  isLogicButtonDisabled,
}: QuestionActionsPropType) {
  const { enableRatingChoiceOrder } = useFeatureToggle()
  const isReverseOrder = useSurveyChoiceOrder()
  const questionCondition = humps.decamelizeKeys({ ...questionAction })
  if (
    questionCondition &&
    questionCondition.is_active &&
    !R.isEmpty(questionCondition.conditions)
  ) {
    const displayConditions = enableRatingChoiceOrder
      ? sortConditionsBySentiment(questionCondition.conditions, isReverseOrder)
      : questionCondition.conditions
    return (
      <TableStyled basic>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell className="tblcustom pleft">Answer contains</Table.HeaderCell>
            <Table.HeaderCell className="tblcustom pright">Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {displayConditions.map((condition, index) => (
            <QuestionAction
              key={index}
              condition={condition}
              shouldShowChoiceValueOnRule={isPrimary || questionCondition.type === 'slider'}
              isOpinionScaleQuestion={questionCondition.is_opinion_scale}
              choices={questionCondition.choices}
              hasImplicitAnswerRule={
                questionCondition.type === 'comment' || questionCondition.type === 'file_upload'
              }
            />
          ))}
          <Table.Row>
            <Table.Cell className="tblcustom pleft" colSpan={2}>
              <a onClick={open} data-testid="edit-actions-btn">
                <i className="far fa-pencil" /> Edit actions
              </a>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </TableStyled>
    )
  } else {
    return (
      <>
        {isLogicButtonDisabled ? (
          <Popup basic tooltip="Actions can be configured after the survey is saved">
            <LinkButton type="button" disabled={true} data-testid="add-actions-btn">
              <i className="icon far fa-plus" />
              Add actions
            </LinkButton>
          </Popup>
        ) : (
          <LinkButton type="button" onClick={open} data-testid="add-actions-btn">
            <i className="icon far fa-plus" />
            Add actions
          </LinkButton>
        )}
      </>
    )
  }
}

export const followUpQuestionText = {
  comment: 'Comment box',
  multipleChoice: 'Multiple choice',
}

export type Choice = {
  id?: number
  is_active: boolean
  label: string
  value: string
  order: number
  sentiment?: string
}

type ConditionQuestion = {
  id?: number
  metric: 'CSAT' | 'NPS' | 'CES' | 'CUSTOM'
  text: string
  type: 'multipleChoice' | 'comment' | 'file_upload'
  is_required: boolean
  is_end_survey: boolean
  choices: Choice[]
}

export type Condition = {
  id?: number
  is_active: boolean
  action: 'display_follow_up_question' | 'finish_survey'
  rules: number[] | string[]
  conditional_question_type:
    | 'follow_up_comment_question'
    | 'follow_up_file_upload_question'
    | 'follow_up_multiple_choice_question'
  follow_up_comment_question: ConditionQuestion
  follow_up_file_upload_question: ConditionQuestion
  follow_up_multiple_choice_question: ConditionQuestion
}
type QuestionCondition = {
  is_active: boolean
  conditions: Condition[]
  choices: Choice[]
  metric: 'CSAT' | 'NPS' | 'CES' | 'CUSTOM'
  is_opinion_scale: boolean
  type: string
}

type QuestionActionsPropType = {
  questionAction: QuestionCondition
  isPrimary: boolean
  open: Function
  isLogicButtonDisabled: boolean
}



// WEBPACK FOOTER //
// ./src/components/QuestionActions/index.tsx